
import UseRestart from "@/hook/UseRestart";
import { computed, defineComponent, PropType, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ReStart",
  props: {
    vin: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const carVin = computed<string>(() => props.vin);
    const { t } = useI18n();

    const softReset = 1;
    const hardReset = 2;
    const isClickable = ref(false);
    const reStart = () => {
      isClickable.value = true;
      UseRestart(carVin.value);
      setTimeout(() => {
        isClickable.value = false;
      }, 3000);
    };

    return { reStart, isClickable, t };
  },
});
